<template>
    <div class="p-3">
        <h3>Detail Surat Konsultasi</h3>
        <hr>

        <div class="row">
            <div class="col-md-3">
                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Data Pasien</div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tbody>
                                <tr>
                                    <td>No. RM</td>
                                    <td>{{ detail_konsul.Medrec }}</td>
                                </tr>
                                <tr>
                                    <td>No. Registrasi</td>
                                    <td>{{ detail_konsul.Regno }}</td>
                                </tr>
                                <tr>
                                    <td>Nama Pasien</td>
                                    <td>{{ detail_konsul.Firstname }}</td>
                                </tr>
                                <tr>
                                    <td>Kategori</td>
                                    <td>{{ detail_konsul.NmKategori }}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>{{ detail_konsul.Sex }}</td>
                                </tr>
                                <tr>
                                    <td>Umur</td>
                                    <td>{{ detail_konsul.umur_pasien }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-8">
                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Detail Surat Konsul</div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tbody>
                                <tr>
                                    <td width="20%">No. Surat Konsul</td>
                                    <td colspan="3">{{ detail_konsul.NoSuratKonsul }}</td>
                                </tr>
                                <tr>
                                    <td>Tanggal Konsul</td>
                                    <td colspan="3">{{ detail_konsul.tanggal_konsul }}</td>
                                </tr>
                                <tr>
                                    <td>Poli Asal</td>
                                    <td>{{ detail_konsul.poli_asal }}</td>
                                    <td>Dokter Pengirim</td>
                                    <td>{{ detail_konsul.doc_asal }}</td>
                                </tr>
                                <tr>
                                    <td>Poli Tujuan</td>
                                    <td>{{ detail_konsul.poli_tujuan }}</td>
                                    <td>Dokter Tuju</td>
                                    <td>{{ detail_konsul.doc_tujuan }}</td>
                                </tr>
                                <tr>
                                    <td>Diagnosa</td>
                                    <td colspan="3">{{ detail_konsul.diagnosa }}</td>
                                </tr>
                                <tr>
                                    <td>Terapi</td>
                                    <td colspan="3">{{ detail_konsul.Terapi }}</td>
                                </tr>
                                <tr>
                                    <td>Catatan</td>
                                    <td colspan="3">{{ detail_konsul.Catatan }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return {
            Regno: '',
            detail_konsul: []
        }
    },
    created(){
        this.Regno = this.$route.params.Regno
    },
    mounted(){
        this.getDetail()
    },
    methods: {
        getDetail(){
            const uri = `/api/konsul-poli/get-detail?Regno=${this.Regno}`

            this.axios.get(uri).then(response => {
                const status = response.data.status;

                if(status == 'success'){
                    this.detail_konsul = response.data.data_konsul;
                }
            })
        }
    }
}
</script>